import React, { Component } from 'react'
import { get } from '../../utils/networking'
import moment from 'moment'
import { connect } from 'react-redux'
import { configs } from '../../helpers/constants'
import FacebookProvider, { Comments, Like, Share } from 'react-facebook'
import { Route, NavLink, HashRouter } from "react-router-dom"
import $ from "jquery"

class BlogDetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            title: '',
            photo: '',
            synopsis: '',
            content: '',
            publicDate: '',
            slug: '',
            category: {
                name: '',
                slug: ''
            },
            author: {
                avatar: '',
                firstName: '',
                lastName: '',
                email: '',
                about: ''
            }
        }

    }

    componentWillReceiveProps(nextProps) {
        const slug = nextProps.match.params.slug
        if (this.slug != slug)
            this.getBlog(slug)
    }

    componentDidMount() {
        const slug = this.props.match.params.slug
        this.slug = slug
        this.getBlog(slug)
    }

    getBlog(slug) {
        get('blog/' + this.slug, "", result => {
            this.setState({
                ...result
            })
        })
    }


    headerBlog(e) {
        e.preventDefault();
        var sub = $('.menu_blog .accordion_show');
        var click_open = $('.tagline p.click_open');
        var icon = $('.tagline i.fa');
        icon.addClass('fa-angle-down');
        if (sub.is(':visible')) {
            $(click_open).removeClass('open');
            $(click_open).addClass('close');
            $(icon).removeClass('fa-angle-up');
            $(icon).addClass('fa-angle-down');
            sub.slideUp();
        } else {
            $(click_open).removeClass('close');
            $(click_open).addClass('open');
            $(icon).removeClass('fa-angle-down');
            $(icon).addClass('fa-angle-up');
            sub.slideDown();
        }
    }


    render() {
        $("html, body").animate({ scrollTop: 0 }, 400);
        const {
            title,
            photo,
            synopsis,
            content,
            publicDate,
            slug,
            category,
            author
        } = this.state

        const { categories } = this.props

        const link = configs.domain + "blog/" + slug
        return (
            <div>
                <main>
                    <div className="border_line_bottom">
                        <div className="container">
                            <div className="content clearfix page_detail_blog">
                                <div className="content_main clearfix">
                                    <div className="header_blog">
                                        <div className="clearfix">
                                            <div className="logo_blog">
                                                <span>BLOG</span>
                                            </div>
                                            <div className="tagline">
                                                <p>Your guide to living well, all year long!</p>
                                                <p className="categories click_open" onClick={this.headerBlog}>CATEGORIES <i className="fa fa-angle-down"></i></p>
                                            </div>
                                        </div>
                                        <div className="menu_blog">
                                            <div className="clearfix">
                                                <ul className="clearfix accordion_show" style={{ display: 'none' }}>
                                                    {categories[0] && categories[0].categories.map((item, index) =>
                                                        <li key={index}><NavLink to={"/blog/category/" + item.slug}>{item.name}</NavLink></li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix">
                                        <div className="left col_12 col_sm_12" >
                                            <div className="border_right" style={{ border: "none", padding: "0px" }}>
                                                <div className="querytotalhitscount">
                                                    <nav>
                                                        <NavLink className="b-link" to="/">Home</NavLink> /&nbsp;
                                                        <NavLink className="b-link" to="/blog" >Blog</NavLink> /&nbsp;
                                                        <NavLink className="b-link" to={"/blog/category/" + category.slug}>{category.name}</NavLink> /&nbsp;
                                                        <span>{title}</span>
                                                    </nav>
                                                </div>
                                                <div className="list_blog" id="shareContent" style={{ padding: "0px" }}>
                                                    <div className="querytotalhitscount">
                                                        <h3 className="title_page">{title}</h3>
                                                    </div>
                                                    <div className="row_col">
                                                        <nav>
                                                            Published: {moment(publicDate).format("dddd, MMMM DD YYYY")} in <NavLink className="b-link" to={"/blog/category/" + category.slug}>{category.name}</NavLink> by <NavLink className="b-link" to="/">Spafinder</NavLink>
                                                        </nav>
                                                        <div className="img">
                                                            <img src={configs.api_domain + photo} alt="" />
                                                        </div>
                                                        <div dangerouslySetInnerHTML={{ __html: content }} className="text">
                                                        </div>
                                                    </div>
                                                    <div className="button_share">
                                                        <FacebookProvider appId="1837433456548793">
                                                            <Share href={link} quote={title}>
                                                                <NavLink to="#" className="facebook"><i className="fa fa-facebook" aria-hidden="true"></i> Facebook</NavLink>
                                                            </Share>
                                                        </FacebookProvider>
                                                    </div>
                                                    <div className="comment_facebook">
                                                        <FacebookProvider appId="1837433456548793">
                                                            <Comments href={link} width={"100%"} />
                                                        </FacebookProvider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="right col_4 col_sm_12">
                                            <div id="ct_map" className="clearfix ct_map">
                                                <section>
                                                    <form>
                                                        <div className="content-form clearfix">
                                                            <input type="text" name="s" placeholder="Search Articles" className="input_text" />
                                                            <input type="submit" className="input_submit" value="Search" />
                                                        </div>
                                                    </form>
                                                </section>
                                                <section>
                                                    <h3 className="gform_title">Newsletter subscription</h3>
                                                    <p>Get instant access to weekly tips and tricks for living well, plus exclusive offers and updates from Spafinder!</p>
                                                    <form>
                                                        <div className="content-form clearfix">
                                                            <input type="text" name="s" placeholder="Enter Email Address" className="input_text" />
                                                            <input type="submit" className="input_submit" value="Sign Up" />
                                                        </div>
                                                    </form>
                                                </section>
                                                <section>
                                                    <div className="b-follow">
                                                        <NavLink to="#" className="b-follow__link b-follow__fb"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__tw"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__instgr"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__pin"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__yt"></NavLink>
                                                    </div>
                                                </section>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }

}

export default connect(
    state => ({
        categories: state.header.wellnessLifeStyle
    })
)(BlogDetails)


// WEBPACK FOOTER //
// ./src/components/blogDetails/index.js